import React, { useState } from "react";
import VizWrapper from "@components/common/Base/VizWrapper";
import Title from "@components/common/Title";
import { IFrameWrapperDynamicZoneModel } from "@models/strapi-components/iframe-wrapper";
import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

export interface IFrameWrapperProps {
  componentData: IFrameWrapperDynamicZoneModel;
}

const IFrameWrapper: React.FC<IFrameWrapperProps> = ({ componentData }) => {
  const { title, iFrames } = componentData;
  const firstIframe = iFrames?.[0];
  const [selectedIframeSlug, setSelectedIframeSlug] = useState<string>(
    firstIframe?.slug
  );

  const selectedIframe = iFrames?.find(
    (iframe) => iframe.slug === selectedIframeSlug
  );

  const { iFrameUrl } = selectedIframe ?? {};

  return (
    <VizWrapper
      style={{ backgroundColor: "#FFFFFF" }}
      className="px-8 xl:px-40"
    >
      <div className="mb-8 lg:mb-0">
        <Title
          variant="h2"
          titleText={title}
          className="text-center mx-auto lg:ml-0"
          // style={{ marginBottom: 0 }}
        />

        <div className="flex justify-center w-full mt-8">
          <div className="flex justify-center gap-8">
            {iFrames.map((iFrame) => {
              const { slug, title } = iFrame;
              const isSelected = selectedIframeSlug === iFrame.slug;
              return (
                <div key={slug} className="relative">
                  <motion.button
                    className={twMerge(
                      " md:text-[20px] md:leading-[32px] font-bold",
                      isSelected ? "white" : "text-dark-purple-50"
                    )}
                    style={{
                      color: isSelected ? "#FC5E01" : "#291E30",
                    }}
                    onClick={() => setSelectedIframeSlug(slug)}
                  >
                    {title}
                  </motion.button>
                  {isSelected && (
                    <motion.span
                      layoutId="bubble"
                      className="absolute inset-0 z-10 bg-primary-orange-50 bottom-0"
                      style={{ borderRadius: 9999, height: 4, top: 32 }}
                      transition={{
                        type: "spring",
                        bounce: 0.2,
                        duration: 0.6,
                      }}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className=" overflow-hidden scrollbar-hide">
          <iframe
            className="h-[2200px] 3xl:h-[1400px] w-full"
            src={iFrameUrl}
            title="Integration Page"
          ></iframe>
        </div>
      </div>
    </VizWrapper>
  );
};

export default IFrameWrapper;
